module.exports = __webpack_public_path__ + "img/rifle.lr300.space.35c72017.png";